import { createContext } from 'react';

const legajoContext = createContext();

export default legajoContext;